import { CreatorsToActions } from '../helper'

type Actions = CreatorsToActions<typeof import('../actions/searchQuery')>

interface State {
  page: string
  sender: string
  category: string
  important_flg: string
  hot_news_flg: string
  close_flg: string
  post: string
  push: string
  progress: string
}
// ______________________________________________________
//
export function initialState(injects?: State): State {
  return {
    page: '',
    sender: '',
    category: '',
    important_flg: '',
    hot_news_flg: '',
    close_flg: '',
    post: '',
    push: '',
    progress: ''
  }
}
// ______________________________________________________
//
export function reducer(state = initialState(), action: Actions): State {
  switch (action.type) {
    case 'SET_SEARCH_QUERY':
      return {
        page: action.payload.page,
        sender: action.payload.sender,
        category: action.payload.category,
        important_flg: action.payload.important_flg,
        hot_news_flg: action.payload.hot_news_flg,
        close_flg: action.payload.close_flg,
        post: action.payload.post,
        push: action.payload.push,
        progress: action.payload.progress
      }
    case 'UNSET_SEARCH_QUERY':
      return {
        page: '',
        sender: '',
        category: '',
        important_flg: '',
        hot_news_flg: '',
        close_flg: '',
        post: '',
        push: '',
        progress: ''
      }
    default:
      return state
  }
}
